import View from './view';
export const PollsCards = View;
